<ion-header class="header --w-back-button">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item
          *ngFor="let breadcrumb of breadcrumbs"
          class="breadcrumb__item"
          detail="false"
          routerDirection="back"
          [routerLink]="[breadcrumb.link]"
        >
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.eventContents" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title class="--logo">
      <a class="header__logo" [routerLink]="['/']">
        <app-logo></app-logo>
      </a>
      <span [innerHTML]="'EVENT_FORM_PAGE.TITLE' | translate"></span>
    </ion-title>
    <ion-buttons slot="end">
      <ion-avatar class="header__avatar" [routerLink]="['..', routes.settings]">
        <img class="header__avatar__image" src="/assets/avatar/anna.svg" [alt]="(user$ | async)?.firstName" />
      </ion-avatar>
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="create-event">
  <div class="white-wrapper">
    <span class="create-event__title" [innerHTML]="'EVENT_FORM_PAGE.TITLE' | translate"></span>
    <form class="create-event__form" [formGroup]="form">
      <ion-item class="create-event__form__item">
        <ion-label class="create-event__form__item__label" position="stacked" [innerHTML]="'EVENT_FORM_PAGE.DATE' | translate"></ion-label>
        <ion-input
          id="open-date-trigger"
          class="create-event__form__item__input"
          [placeholder]="'Select date'"
          [value]="form.value.date | date:'dd. MMMM YYYY HH:mm'"
        ></ion-input>
        <ion-popover [size]="'cover'" trigger="open-date-trigger">
          <ng-template>
            <ion-datetime
              class="create-event__form__item__input"
              locale="de-DE"
              formControlName="date"
              displayFormat="DD. MMM YYYY HH:mm"
              [cancelText]="'BUTTONS.CANCEL' | translate"
              [doneText]="'BUTTONS.OK' | translate"
              [max]="minDate.getFullYear() + 5"
            ></ion-datetime>
          </ng-template>
        </ion-popover>
      </ion-item>

      <ion-item class="create-event__form__item">
        <ion-label
          class="create-event__form__item__label"
          position="stacked"
          [innerHTML]="'EVENT_FORM_PAGE.CLOSING_DATE' | translate"
        ></ion-label>
        <ion-select
          class="create-event__form__item__input"
          formControlName="closingDate"
          [cancelText]="'BUTTONS.CANCEL' | translate"
          [okText]="'BUTTONS.OK' | translate"
        >
          <ion-select-option [value]="4320" [innerHTML]="'EVENT_FORM_PAGE.THREE_DAYS_BEFORE' | translate"></ion-select-option>
          <ion-select-option [value]="1440" [innerHTML]="'EVENT_FORM_PAGE.ONE_DAY_BEFORE' | translate"></ion-select-option>
          <ion-select-option [value]="720" [innerHTML]="'EVENT_FORM_PAGE.TWELVE_HOURS_BEFORE' | translate"></ion-select-option>
          <ion-select-option [value]="60" [innerHTML]="'EVENT_FORM_PAGE.ONE_HOUR_BEFORE' | translate"></ion-select-option>
          <ion-select-option [value]="15" [innerHTML]="'EVENT_FORM_PAGE.FIFTEEN_MINUTES_BEFORE' | translate"></ion-select-option>
          <ion-select-option [value]="0" [innerHTML]="'EVENT_FORM_PAGE.STARTING_TIME' | translate"></ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item class="create-event__form__item">
        <ion-label
          class="create-event__form__item__label"
          position="stacked"
          [innerHTML]="'EVENT_FORM_PAGE.REFERENT' | translate"
        ></ion-label>
        <ion-select
          class="create-event__form__item__input"
          formControlName="referentId"
          [cancelText]="'BUTTONS.CANCEL' | translate"
          [okText]="'BUTTONS.OK' | translate"
        >
          <ion-select-option *ngFor="let referent of referents$ | async" [value]="referent.id">{{ referent.name }}</ion-select-option>
        </ion-select>
      </ion-item>

      <ion-item class="create-event__form__item">
        <ion-label class="create-event__form__item__label" position="stacked" [innerHTML]="'EVENT_FORM_PAGE.URL' | translate"></ion-label>
        <ion-input
          class="create-event__form__item__input"
          formControlName="location"
          [placeholder]="'EVENT_FORM_PAGE.URL_PLACEHOLDER' | translate"
        ></ion-input>
      </ion-item>

      <div class="create-event__form__footer">
        <ion-button class="button --tertiary" [innerHTML]="'BUTTONS.CANCEL' | translate | lowercase" (click)="cancel()"></ion-button>
        <ion-button
          class="button --primary"
          [innerHTML]="'BUTTONS.SAVE' | translate"
          [disabled]="form.invalid || form.pristine || (loading$ | async)"
          (click)="save()"
        ></ion-button>
      </div>
    </form>
  </div>
</ion-content>
